import i18n from '../i18n'

export const locale = (value: string): string => {
  try {
    if (!i18n) {
      return value
    }
    if (i18n.language == 'it') {
      return value
    }
    const spaceStart = value.startsWith(' ') ? ' ' : ''
    const spaceEnd = value.endsWith(' ') ? ' ' : ''
    const dotEnd = value.endsWith('.') ? '.' : ''
    let valueToLocale = value
    if (dotEnd != '') {
      valueToLocale = valueToLocale.substr(0, valueToLocale.length - 1)
    }
    const columnEnd = valueToLocale.endsWith(':') ? ':' : ''
    if (columnEnd != '') {
      valueToLocale = valueToLocale.substr(0, valueToLocale.length - 1)
    }
    valueToLocale = valueToLocale.replaceAll("'", '').replaceAll('"', '')
    if (!i18n.exists(valueToLocale.toLowerCase().trim())) {
      return value
    }
    let newValue = i18n.t(valueToLocale.toLowerCase().trim())
    if (valueToLocale.charAt(0) === valueToLocale.charAt(0).toUpperCase()) {
      if (valueToLocale === valueToLocale.toUpperCase()) {
        newValue = newValue.toUpperCase()
      } else {
        if (newValue.length > 1) {
          newValue = newValue.charAt(0).toUpperCase() + newValue.slice(1).toLowerCase()
        }
      }
    } else {
      newValue = newValue.toLowerCase()
    }

    return spaceStart + newValue + spaceEnd + columnEnd + dotEnd
  } catch (e) {
    console.log(value, e)
    return value
  }
}

export const errorMessage = 'Error'
